import { logger } from '@luna/logger';

const encodeUrlSafeString = (str: string): string => {
    let encoded = str.replace(/=+$/, '');
    encoded = encoded.split('+').join('-').split('/').join('_');
    return encoded;
};

/**
 * @description
 * This function encodes given string as base64url.
 *
 * @param {string} str - The string to be encoded.
 * @returns {string} The encoded string.

 * @example
 * const encodedString = base64UrlDecode('Hello, world!');
 * console.log(decodedString); // Output: 'SGVsbG8sIHdvcmxkIQ'
 */
export const base64UrlEncode = (str?: string): string => {
    if (!str) {
        logger.error('Error: can not encode an empty string');
        return '';
    }
    return encodeUrlSafeString(window.btoa(str));
};
